export default "__VITE_ASSET__mRCQgPnw__"